import { type Writable, writable } from "svelte/store";
import { descending } from "./helpers";
import { User, UserRole, WalletTransaction, PlayGroups, PlayGroupDTO } from "./walletapi";
import { service } from "./services";
import { RegisterStartupCallback } from "./startup";
// import { GetSessionToken } from "./user";

export const owners = writable<User[]>([]);
export const admins = writable<User[]>([]);
export const cashiers = writable<User[]>([]);
export const players = writable<User[]>([]);
export const playGroupsList = writable<PlayGroupDTO[]>([]);

const TOKEN_STORAGE_KEY = "token";
function GetSessionToken() {
const token = sessionStorage.getItem(TOKEN_STORAGE_KEY);
return token ? token : undefined; 
 }


export const roles: UserRole[] = [
    UserRole.Owner,
    UserRole.Admin,
    UserRole.Cashier,
    UserRole.Player
];

export const usersByRole: Record<UserRole, Writable<User[]>> = {
    [UserRole.Owner]: owners,
    [UserRole.Admin]: admins,
    [UserRole.Cashier]: cashiers,
    [UserRole.Player]: players
};



// No aplicar ordenamiento - mantener el orden del backend
const defaultSort = (a: User, b: User) => 0;

export async function UserListStartup(firstStartup: boolean)
{
    await RefreshUsers();

    if (!firstStartup)
    {
        return;
    }
    service.walletapi.registerOperation("UserChanged", "UserChanged", UserChanged);
    service.walletapi.registerOperation("UserAdded", "UserAdded", UserAdded);
    service.walletapi.registerOperation("NewTransaction", "NewTransaction", NewTransaction);
}

RegisterStartupCallback("UserListStartup", UserListStartup);


export async function RefreshUsers()
{
    let userList = await service.walletapi.listAllUsers({
        Token: GetSessionToken()
    });

    if (!userList.Success)
    {
        return;
    } 
    for (let role of roles)
    {
        let userListFiltered = userList.Data!.filter(u => u.Role == role);
        usersByRole[role].set(userListFiltered); // No aplicar ordenamiento
    }
}

//for playgroups 
export async function RefreshPlayGroups()
{
    let playgroupsList = await service.walletapi.playGroupsList({
        Token: GetSessionToken()
    });
    if (!playgroupsList.Success)
    {
        return;
    }

    playGroupsList.set(playgroupsList.Data!);
}


export function UserAdded(user: User)
{
    const userList = usersByRole[user.Role];
    userList.update(list => {
        list.push(user);
        return list; // No aplicar ordenamiento
    });
};

export function UserChanged(user: User)
{
    const userList = usersByRole[user.Role];
    
    userList.update(list => {
        let index = list.findIndex(p => p.Id == user.Id);
        if (index == -1)
        {
            // no such user
            return list;
        }

        // copy transaction if exists in old, but not in new
        let oldUser = list[index];
        if (oldUser.LastWalletTransaction &&
            !user.LastWalletTransaction)
        {
            user.LastWalletTransaction = oldUser.LastWalletTransaction;
            user.LastWalletTransaction = oldUser.LastWalletTransaction;
        }
        
        list[index] = user;

        return list;
    });
};

export function NewTransaction(transaction: WalletTransaction)
{
    // TODO find user no matter the role
    players.update(list => {
        let userIndex = list.findIndex(p => p.Id == transaction.UserId);
        if (userIndex == -1)
        {
            // no such player
            return list;
        }

        list[userIndex] = {
            ...list[userIndex],
            LastWalletTransaction: transaction,
            LastWalletTransactionId: transaction.Id
        };

        return list; // No aplicar ordenamiento
    });
};

//pin for withdrawal
// export async function WithdrawalPin(pin: string)
// {
//     console.log('Iniciando WithdrawalPin');
//     let pinResponse = await service.walletapi.withdrawalPin({
//         Token: GetSessionToken(),
//         Data: {
//             Pin: pin
//         }
//     });

//     console.log('Respuesta de withdrawalPin:', pinResponse);
//     if (!pinResponse.Success)
//     {
//         console.error('Error al refrescar playgroups:', pinResponse);
//         return;
//     }

//     console.log('Pin de retiro:', pinResponse.Data);
// }   